import { useState, useEffect } from 'react';
import { getOfferSchemaWithEdgeFunction } from '../api/offerSchemaWithEdgeFunction';
import { OfferLetterSchema } from '../types';

export const useOfferSchema = (
  organizationId: string | undefined,
  isOpen: boolean,
  outletId?: string,
  jobId?: string
) => {
  const [schema, setSchema] = useState<OfferLetterSchema | null>(null);
  const [htmlTemplate, setHtmlTemplate] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) {
      setSchema(null);
      setHtmlTemplate('');
      setError(null);
      return;
    }

    if (!organizationId) return;

    let cancelled = false;
    const loadSchema = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data, error: apiError } = await getOfferSchemaWithEdgeFunction(
          organizationId,
          outletId,
          jobId
        );
        if (cancelled) return;

        if (apiError) {
          setError('Failed to load offer schema');
          return;
        }

        if (!data?.schema || typeof data.schema !== 'object') {
          setError('Offer schema not found');
          return;
        }

        setSchema(data.schema as OfferLetterSchema);
        setHtmlTemplate(typeof data.html_template === 'string' ? data.html_template : '');
      } catch (err: any) {
        if (!cancelled) {
          setError('An unexpected error occurred');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadSchema();

    return () => {
      cancelled = true;
    };
  }, [isOpen, organizationId, outletId, jobId]);

  return { schema, htmlTemplate, loading, error };
};
